import { Dispatch } from "redux";
import api from ".";
import { getTag } from "../Action/tag.action";

export const getAllTags = (id: any) => (dispatch: Dispatch) => {
    api.get(`/tags/${id}`)
        .then((response) => {
            dispatch(getTag(response.data));
        })
        .catch((err) => {});
};
